import { toast } from 'react-toastify';
import {
  ActivityAssociation,
  File as DrmFile,
  FilePreprocessStatus,
  FileType,
} from 'v2/models';
import restFactory from './restFactory';

export type FileTypes =
  | 'Legal Document'
  | 'Data Dictionary'
  | 'Marketing Materials'
  | 'Sample Data'
  | 'Technical Documentation'
  | 'Other';

export const FileTypeDisplayString: Record<keyof typeof FileType, FileTypes> = {
  legal_document: 'Legal Document',
  data_dictionary: 'Data Dictionary',
  marketing_materials: 'Marketing Materials',
  sample_data: 'Sample Data',
  technical_documentation: 'Technical Documentation',
  other: 'Other',
};

export const FileTypeOptions = Object.values(FileType).map((key) => ({
  label: FileTypeDisplayString[key],
  value: key,
}));

export interface FileFormFields {
  id?: number;
  file: File;
  type: FileType;
  description: string;
  relationships: ActivityAssociation[];
}

export interface BulkFilesFormFields {
  files: string;
  type: FileType;
}

type FileSignedUrl = {
  signed_url?: string;
};

export const isFileRunning = (file?: DrmFile) => {
  return file && file.preprocess_status === FilePreprocessStatus.RUNNING;
};

export const downloadDRMFile = async (fileUrl: string, fileName: string) => {
  await restFactory
    .get<Blob>(fileUrl, undefined, undefined, {
      responseType: 'blob',
    })
    .then((blob) => {
      const href = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch(() => {
      toast.error('Error downloading file.');
    });
};

export const openFile = async (fileURL: string) => {
  await restFactory
    .get<FileSignedUrl>(fileURL)
    .then((response: FileSignedUrl) => {
      const signedUrl = response['signed_url'];
      window.open(signedUrl, '_blank');
    })
    .catch(() => {
      toast.error('Error opening file');
    });
};
